/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import ImgPoint from '../../../../../assets/animation_point.gif';

import './animation027.less';

interface IAnimation027Item {
  text: string;
  title: string;
  color: string;
}

interface IAnimation027Props {
  items: IAnimation027Item[];
  className?: string;
  onCompleted?: () => void;
}

const Animation027: React.FunctionComponent<IAnimation027Props> = ({
  items,
  className,
  onCompleted,
}) => {
  const [play, setPlay] = React.useState(1);
  const [isPlayed, setIsPlayed] = React.useState(false);
  const startPlay = (next = 1) => {
    if (isPlayed) {
      return;
    }
    next += 1;
    setPlay(next);
    setIsPlayed(true);
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1000);
    } else {
      console.log('Animation021 onCompleted');
      onCompleted && onCompleted();
    }
  };

  return (
    <div className={`animation027 component ${className || ''}`}>
      {items.map((itm: IAnimation027Item, idx: number) => (
        <>
          <div
            key={idx}
            className={`animation027-item animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
            onClick={() => startPlay()}
          >
            <img
              className={`click-point ${play > 1 ? 'hide' : ''}`}
              src={ImgPoint}
              alt=""
            />
            <div
              className="animation027-color-div"
              style={{ backgroundColor: itm.color }}
            >
              <div
                className="animation027-title"
                dangerouslySetInnerHTML={{ __html: itm.title }}
                style={{ backgroundColor: itm.color }}
              />
            </div>
            <div
              className="animation027-text"
              dangerouslySetInnerHTML={{ __html: itm.text }}
            />
          </div>
        </>
      ))}
    </div>
  );
};

export default Animation027;
